import { render, staticRenderFns } from "./liveClassFestivalToBeReviewed.vue?vue&type=template&id=d572fd5e"
import script from "./liveClassFestivalToBeReviewed.vue?vue&type=script&lang=js"
export * from "./liveClassFestivalToBeReviewed.vue?vue&type=script&lang=js"
import style0 from "./liveClassFestivalToBeReviewed.vue?vue&type=style&index=0&id=d572fd5e&prod&lang=less&scope=true"
import style1 from "./liveClassFestivalToBeReviewed.vue?vue&type=style&index=1&id=d572fd5e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports